import React, { useState, useEffect } from 'react';
import SearchForm from '../Forms/SearchForm';
import useGlobal from '../../store';
import SearchResult from '../General/SearchResult';
import { Spinner } from 'reactstrap';

const SearchFormPanel = (props) => {

    const [isSearching, setIsSearching] = useState(false);

    const [response, giftideaActions] = useGlobal(
        state => state.response,
        actions => actions.giftideaActions
    );

    const searchForItems = (keywords) => {
        console.log('search', keywords);
        setIsSearching(true);
        giftideaActions.searchAmazon({searchTerm:keywords});
    }

    useEffect(() => {
        if(!response || response.type !== "searchamazon") {
            return;
        }
        setIsSearching(false);
    }, [response]);

    const searchResults = (response && response.type === "searchamazon" && response.data) ? response.data.map(item => <SearchResult key={item.itemName} handler={props.addItemHandler} item={item}></SearchResult>) : <></>;
    
    return (
        <>
            <SearchForm handler={searchForItems}></SearchForm>
            <div>
                {isSearching ? <div className="pt-4"><Spinner></Spinner> Searching</div> : <></>}
                {searchResults}
            </div>
        </>
    );
}

export default SearchFormPanel;